"use client";
import React, { useState } from 'react';
import SimpleOfferModal from './SimpleOfferModal';
import { Offer, ProductData } from '@/services/dataTypes';
import { getFinalDiscountTag } from '@/constants/hooks';
import Link from 'next/link';

interface Props {
    offer:             Offer | ProductData;
    merchantHref:      string;
    imageSrc:          string;
    merchantImg?:      string | null;
    domain:            string;
    type:              'anchor' | 'button';
    buttonClass?:      string;
    isDetail?:         number;           // if 1 → redirect to product detail page
    productDetailUrl?: string | null;    // product detail page URL
}

const OfferDetailsToggle = ({
    offer, merchantHref, domain, type, buttonClass,
    imageSrc, merchantImg, isDetail, productDetailUrl,
}: Props) => {
    const [open, setOpen] = useState(false);

    const handleClick = (e: React.MouseEvent) => {
        e.preventDefault();
        e.stopPropagation();
        setOpen(true);
    };

    const originalPrice   = offer?.original_price ? parseFloat(offer.original_price) : 0;
    const salePrice       = offer?.sale_price      ? parseFloat(offer.sale_price)     : 0;
    const discountPercent = originalPrice > 0 && salePrice > 0
        ? Math.round(((originalPrice - salePrice) / originalPrice) * 100)
        : null;

    const finalDiscountTag = getFinalDiscountTag(
        offer?.offer_title || offer?.offer_detail,
        discountPercent,
    );

    const sharedClass = buttonClass ||
        'text-[10px] font-bold text-slate-400 hover:text-[#D61C4E] transition-colors uppercase tracking-wider';

    /* ── If is_detail === 1 AND productDetailUrl exists → Link to detail page ── */
    if (isDetail === 1 && productDetailUrl) {
        return (
            <Link
                href={productDetailUrl}
                className={`no-underline hover:underline underline-offset-2 relative z-[5] ${sharedClass}`}
            >
                View Details
            </Link>
        );
    }

    /* ── Otherwise → open SimpleOfferModal ── */
    return (
        <>
            {type === 'anchor' ? (
                <span
                    onClick={handleClick}
                    className={`cursor-pointer select-none ${sharedClass}`}
                >
                    View Details
                </span>
            ) : (
                <button
                    onClick={handleClick}
                    className={`cursor-pointer ${sharedClass}`}
                >
                    View Details
                </button>
            )}

            {open && (
                <SimpleOfferModal
                    data={offer}
                    onClose={() => setOpen(false)}
                    domain={domain}
                    finalDiscountTag={finalDiscountTag}
                    merchantHref={merchantHref}
                    merchantImg={merchantImg}
                    productImg={imageSrc}
                />
            )}
        </>
    );
};

export default OfferDetailsToggle;
